import useDesktopChecker from "hooks/useDesktopChecker";
import React, { useEffect } from "react";
import styles from "./drawer.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import NewHeaderLogo from "assets/images/nafhub-light-logo.svg";
import { Button } from "../button/Button";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  closeDescription?: string;
  closeText?: string;
  customCss?: string;
  footerText?: string;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose, title, children, customCss, closeDescription, closeText, footerText }) => {
  const isDesktop = useDesktopChecker();

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <>
          <div className={`${styles.drawerOverlay} ${isOpen ? styles.open : ""}`} />
          <div className={`${styles.drawer} ${isDesktop ? styles.desktop : styles.mobile} ${isOpen ? styles.open : ""} ${customCss ?? ""}`}>
            <div className={styles.drawerHeader}>
              <div className={styles.left}>
                <img className={styles.nhLogo} src={NewHeaderLogo} alt="nafhub logo" />
                <FontAwesomeIcon className={styles.chevron} icon={regular("chevron-right")} />
                <span className={styles.title}>{title}</span>
              </div>
              <FontAwesomeIcon onClick={onClose} role="button" aria-label="Close" className={styles.closeButton} icon={regular("close")} />
            </div>
            {children && <div className={styles.drawerBody}>{children}</div>}

            <div className={styles.drawerFooter}>
              <div className={styles.footerLeftText}>{footerText}</div>

              <div className={styles.footerRight}>
              {closeDescription && <span className={styles.closeDescription}>{closeDescription}</span>}
              
              <Button title={closeText} type={"round"} variant={"primary"} onClick={onClose} />
              
              </div>
              
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Drawer;
